export type LibraryFilters = {q:string;grade:string;subject:string;status:string;from:string;to:string;sort:"newest"|"oldest"};
export const emptyLibraryFilters:LibraryFilters = {q:"",grade:"",subject:"",status:"",from:"",to:"",sort:"newest"};

export function libraryParams(filters:LibraryFilters,cursor?:string):URLSearchParams {
  const params=new URLSearchParams({view:"page",limit:"20",sort:filters.sort});
  for (const key of ["q","grade","subject","status"] as const) if (filters[key].trim()) params.set(key,filters[key].trim());
  if (filters.from) params.set("created_from",new Date(`${filters.from}T00:00:00`).toISOString());
  if (filters.to) {
    const end=new Date(`${filters.to}T00:00:00`);end.setDate(end.getDate()+1);
    params.set("created_before",end.toISOString());
  }
  if (cursor) params.set("cursor",cursor);
  return params;
}
